export default __webpack_public_path__ + "static/media/single_web-lg@1x.8ce33db5.jpg";